import { I18n } from '@calendly/i18n'
import { Button } from '@calendly/ui/components/button'
import { AddMiniIcon } from '@calendly/ui/components/icons'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

import { isAvailableFeatureSelector } from 'features/billing'
import { TRACKING_EVENT_NAMES, useTrack } from 'hooks/analytics_events'
import { isAdminOrOwnerSelector } from 'selectors/current_user'

import { ANALYTICS_CTA_CLICK_PROPS_MAP } from '../constants'
import { getPrimaryButtonOptionsByContentKey } from '../utils'

export const ActionButton = ({ button: ButtonComponent, contentKey, featureKey, options }) => {
  const history = useHistory()
  const buttonParams = { history, options }
  const isOwnerOrAdmin = useSelector(isAdminOrOwnerSelector)
  const track = useTrack()
  let isFeatureAvailable = useSelector((state) => isAvailableFeatureSelector(state, { featureKey }))
  if (contentKey === 'admin_dashboard' && !isOwnerOrAdmin) {
    isFeatureAvailable = false
  }
  const buttonLabel = I18n.t(`publisher.empty_state.${contentKey}.primary_button`)

  if (ButtonComponent) {
    return (
      <ButtonComponent
        dropdownOnRight
        canOpenByDefault={false}
        buttonLabel={buttonLabel}
      />
    )
  }

  const primaryButtonOptions = getPrimaryButtonOptionsByContentKey(contentKey, buttonParams)
  const buttonContent = primaryButtonOptions.icon || <AddMiniIcon />

  const onClick = (e) => {
    const properties = ANALYTICS_CTA_CLICK_PROPS_MAP[contentKey]
    if (primaryButtonOptions?.onClick) primaryButtonOptions.onClick(e)
    if (!properties) return

    track({
      name: TRACKING_EVENT_NAMES.CTA_CLICKED,
      entities: ['attribution', 'organization', 'user'],
      properties
    })
  }

  return (
    <Button responsive={false} disabled={featureKey && !isFeatureAvailable} {...primaryButtonOptions} onClick={onClick}>
      {buttonContent}
      {buttonLabel}
    </Button>
  )
}
